import Vue from 'vue';
import Router from 'vue-router';
// import index from '../pages/index';   老首页 v2.5下线
import home from '../pages/home';
import Birthday from '../pages/birthday/';
import Prepare from '../pages/prepare/index';
import Service from '../pages/service/';
import Interestfree from '../pages/interestfree/';
// import Seckill from '../pages/seckill/';
import Seckill from '../pages/activity/rights_day.vue';
import Upgrade from '../pages/upgrade/';
import Address from '../componets/upgrade/Address';
// import Energy from '../pages/energy/index';
import ElmLuckyBag from '../pages/luckybag/index';
import Rule from '../pages/rule/index';
import InterestsDetail from '../pages/interests_detail/index';
import AllBenefitNew from '../pages/all_benefit/newIndex';
import BenefitExchange from '../pages/benefit_exchange/index';
import RecordsEnergy from '../pages/records/energyNew';
import RecordsRight from '../pages/records/right';
import RecordsEntity from '../pages/records/entity';
import GrowthPlan from '../componets/growthPlan/index';
import LifeBenefit from '../pages/life_benenfit/index';
Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: home
        },
        // 生日券
        {
            path: '/birthday',
            name: 'Birthday',
            component: Birthday
        },
        // 权益即将开启页面
        {
            path: '/prepare',
            name: 'Prepare',
            component: Prepare
        },
        // 客服
        {
            path: '/service',
            name: 'Service',
            component: Service
        },
        // 提前还免息
        {
            path: '/interestfree',
            name: 'Interestfree',
            component: Interestfree
        },
        // 权益日
        {
            path: '/seckill',
            name: 'Seckill',
            component: Seckill
        },
        // 升级礼包
        {
            path: '/upgrade',
            name: 'Upgrade',
            component: Upgrade
        },
        // 升级礼包
        {
            path: '/address',
            name: 'Address',
            component: Address
        },
        // // 活力值详情页
        // {
        //     path: '/energy',
        //     name: 'Energy',
        //     component: Energy
        // },
        // 生活福袋
        {
            path: '/elmLuckyBag',
            name: 'ElmLuckyBag',
            component: ElmLuckyBag
        },
        // 权益规则
        {
            path: '/rule',
            name: 'rule',
            component: Rule
        },
        // 生活权益详情
        {
            path: '/interestsDetail',
            name: 'interestsDetail',
            component: InterestsDetail
        },
        // 活力值记录
        {
            path: '/records/energy',
            name: 'RecordsEnergy',
            component: RecordsEnergy
        },
        // 生活权益领取记录
        {
            path: '/records/right',
            name: 'RecordsRight',
            component: RecordsRight
        },
        // 实物领取记录
        {
            path: '/records/entity',
            name: 'RecordsEntity',
            component: RecordsEntity
        },
        // 全部权益
        {
            path: '/allBenefit',
            name: 'AllBenefit',
            component: AllBenefitNew
        },
        // 权益兑换 //需要传query：type = 话费券：14 免息期：0 还款券：1
        {
            path: '/benefitExchange',
            name: 'BenefitExchange',
            component: BenefitExchange
        },
        // 额度成长计划
        {
            path: '/growthPlan',
            name: 'GrowthPlan',
            component: GrowthPlan
        },
        // 生活权益二级页面
        {
            path: '/lifeBenefit',
            name: 'LifeBenefit',
            component: LifeBenefit
        }
    ]
});

// router.afterEach((to, from) => {
// });
export default router;
